<template>
  <div class="$attrs.class">
    <label class="upper">CRISIS CONTACT</label>
    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <div class="form-row">
          <div class="col-12">
            <input-text
              id="name"
              v-model="name"
              name="name"
              label="Name"
              type="text"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-md-6">
            <input-text
              id="title"
              v-model="title"                   
              name="title"
              label="Title"
              type="text"
            />
          </div>

          <div class="col-12 col-md-6">
            <input-text
              id="phoneNumber"
              v-model="phoneNumber"
              name="phoneNumber"
              label="Phone Number"
              type="text"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col-12">
            <input-text
              id="email"
              v-model="email"
              name="email"
              label="Email"
              type="text"
            />
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-wide mt-4"
        >
          <font-awesome-icon
            v-if="school.saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Save Changes</span>
        </button>
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'CrisisContact',

  components: {
    FormComponent,
    InputText,
    InputTextArea,
    InputSelect,
  },

  inject:['school'],

  data() {
    return {
      name: '',
      title: '',
      phoneNumber: '',
      email: '',
    }
  },

  mounted() {
    this.name = this.school.crisisContact.name;
    this.title = this.school.crisisContact.title;
    this.phoneNumber = this.school.crisisContact.phoneNumber;
    this.email = this.school.crisisContact.email;
  },

  methods: {
    async save() {
      const isValid = await this.$validator.validateAll()
      if (!isValid)
        return;

      this.errors.clear();

      try {
        await this.school.updateCrisisContact({
          name: this.name,
          title: this.title,
          phoneNumber: this.phoneNumber,
          email: this.email,
          contactInCrisis: true
        });
        this.$store.commit('setGlobalAlert', {
          msg: 'Crisis Contact Saved!',
        });
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save crisis contact. Please try again!', error: true,
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
label.upper {
    @include label;

    color: $green;
    margin-bottom: 20px;
  }
</style>